<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">
        {{ dialogtitle }}
      </h4>
      <button type="button" class="btn-close" @click="close"></button>
    </template>
    <template v-slot:body>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group custom-check">
            <input
              type="checkbox"
              id="isRequired"
              v-model="isRequired"
              class="z-checkbox-small"
              @click="saveIt"
            />
            <label for="isRequired">required?</label>
          </div>
        </div>
        <div class="col-md-4">
          <z-input
            v-model="appKey"
            name="address1"
            label="App Key"
            validate="required"
            @keyup="saveIt"
          />
        </div>
        <div class="col-md-4">
          <z-input
            v-model="releaseDate"
            name="releaseDate"
            label="Release"
            type="date"
            @change="saveIt"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <z-input
            v-model="name"
            name="name"
            label="Name"
            validate="required"
            @keyup="saveIt"
          />
        </div>
        <div class="col-md-4">
          <z-input
            v-model="version"
            name="version"
            label="Version"
            validate="required"
            @keyup="saveIt"
          />
        </div>
        <div class="col-md-4">
          <z-select
            v-model="OS"
            :options="OSes"
            label="OS"
            validate="required"
            @change="changeOS"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <z-input
            v-model="title"
            name="title"
            label="Title"
            validate="required"
            @keyup="saveIt"
          />
        </div>
        <div class="col-md-6">
          <z-textarea
            v-model="message"
            name="message"
            label="Message"
            validate="required"
            :rows="5"
            @keyup="saveIt"
          />
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-1">
          <span>#{{ id }}</span>
        </div>
        <div class="col-md-6">
          <span v-if="invalidMessage !== ''" class="custom-invalid">{{
            invalidMessage
          }}</span>
        </div>
        <div class="col-md-5">
          <div class="custom-buttons">
            <button
              v-show="isSave"
              class="btn btn-primary me-2"
              @click="performSave(false)"
            >
              Save
            </button>
            <!-- <button
              v-show="isSave"
              class="btn btn-primary me-2"
              @click="performSave(true)"
            >
              Save and Close
            </button> -->
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import ZDialog from '@/Components/ZElements/Dialog'
import ZInput from '@/Components/ZElements/Input'
import ZSelect from '@/Components/ZElements/Select'
import ZTextarea from '@/Components/ZElements/TextArea'
export default {
  name: 'application-dialog',
  components: {
    ZDialog,
    ZInput,
    ZSelect,
    ZTextarea,
  },
  props: {
    show: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalSize: 'modal-lg',
      isSave: false,
      validErrors: [],
      invalidMessage: '',
      OSes: [
        {
          id: 0,
          name: 'ios',
          value: 'ios',
        },
        {
          id: 1,
          name: 'android',
          value: 'android',
        },
      ],
    }
  },
  mounted() {},
  computed: {
    ...mapGetters('configuration', ['application']),
    isVisible() {
      return this.show !== null
    },
    dialogtitle() {
      let _title = 'Edit Application'
      if (this.show) {
        if (this.show.isAdd) {
          _title = 'Add Application'
        } else if (this.application) {
          _title = `Edit Application (${this.application.name})`
        }
      }
      return _title
    },
    isAdd() {
      let _is = false
      if (this.show) {
        _is = this.show.isAdd
      }
      return _is
    },
    id() {
      let _id = ''
      if (this.application) {
        _id = this.application.id
      }
      return _id
    },
    name: {
      get() {
        let _data = ''
        if (this.application) {
          _data = this.application.name
        }
        return _data
      },
      set(value) {
        this.setApplicationData({
          name: 'name',
          value: value,
        })
      },
    },
    appKey: {
      get() {
        let _data = ''
        if (this.application) {
          _data = this.application.appKey
        }
        return _data
      },
      set(value) {
        this.setApplicationData({
          name: 'appKey',
          value: value,
        })
      },
    },
    version: {
      get() {
        let _data = ''
        if (this.application) {
          _data = this.application.version
        }
        return _data
      },
      set(value) {
        this.setApplicationData({
          name: 'version',
          value: value,
        })
      },
    },
    releaseDate: {
      get() {
        let _data = ''
        if (this.application) {
          _data = moment(this.application.releaseDate).format('YYYY-MM-DD')
        }
        return _data
      },
      set(value) {
        this.setApplicationData({
          name: 'releaseDate',
          value: value,
        })
      },
    },
    OS: {
      get() {
        let _data = ''
        if (this.application) {
          _data = this.application.OS
        }
        return _data
      },
      set(value) {
        this.setApplicationData({
          name: 'OS',
          value: value,
        })
      },
    },
    isRequired: {
      get() {
        let _data = ''
        if (this.application) {
          _data = this.application.isRequired === 1 ? true : false
        }
        return _data
      },
      set(value) {
        this.setApplicationData({
          name: 'isRequired',
          value: value ? 1 : 0,
        })
      },
    },
    title: {
      get() {
        let _data = ''
        if (this.application) {
          _data = this.application.title
        }
        return _data
      },
      set(value) {
        this.setApplicationData({
          name: 'title',
          value: value,
        })
      },
    },
    message: {
      get() {
        let _data = ''
        if (this.application) {
          _data = this.application.message
        }
        return _data
      },
      set(value) {
        this.setApplicationData({
          name: 'message',
          value: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('configuration', ['setApplicationData', 'saveApplication']),
    saveIt() {
      this.isSave = true
      this.$emit('saveIt')
    },
    changeOS() {
      this.isSave = true
      this.$emit('saveIt')
    },
    validate() {
      let valid = true
      this.validErrors = []
      this.invalidMessage = ''
      if (this.application.name === '') {
        valid = false
        this.validErrors.push('name')
      }
      if (this.application.releaseDate === null) {
        valid = false
        this.validErrors.push('release')
      }
      return valid
    },
    async performSave(closeIt) {
      this.invalidMessage = ''
      let success = false
      let valid = this.validate()
      if (valid) {
        this.setApplicationData({
          name: 'test',
          value: null,
        })
        // Save Here
        console.log('Save Application', this.application)
        let results = await this.saveApplication(this.application)
        console.log('Saved Application Results', results)
        if (results.error) {
          this.invalidMessage = results.error
        } else {
          success = true
          this.isSave = false
          this.$emit('saved')
          // if (closeIt || this.show.isAdd) {
          //   this.$emit('close')
          // }
        }
      }
      return success
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-body {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-invalid {
  color: red;
  font-weight: 500;
}
.custom-buttons {
  position: relative;
  float: right;
}
.custom-check {
  position: relative;
  top: 30px;
  left: 15px;
  label {
    margin-left: 5px;
  }
}
</style>
